import { gql } from '../../__generated__/gql'

export const CREATE_SONG_REQUEST_MUTATION = gql(`
  mutation createSongRequest(
    $title: String!
    $artist: String!
    $album: String!
  ) {
    createSongRequest(
      input: { title: $title, artist: $artist, album: $album }
    ) {
      songRequestEntry {
        ...songRequestEntryFields
      }
    }
  }
`)
